import angular from 'angular';

import announcementListModule from '../announcement-list/announcement-list-module';
import announcementItemModule from '../announcement-item/announcement-item-module';
import activeAnnouncementsModule from '../active-announcements/active-announcements-module';
import archiveAnnouncementsModule from '../archived-announcements/archived-announcements-module';
import scheduledAnnouncementsModule from '../scheduled-announcements/scheduled-announcements-module';
import announcementPreviewModule from '../announcement-preview/announcement-preview-module';
import announcementFormModule from '../announcement-form/announcement-form-module';

import AnnouncementManegementComponent from './announcements-management-component';

export default angular
  .module('announcement-management', [
    announcementListModule.name,
    announcementItemModule.name,
    activeAnnouncementsModule.name,
    archiveAnnouncementsModule.name,
    scheduledAnnouncementsModule.name,
    announcementFormModule.name,
    announcementPreviewModule.name,
  ])
  .component('announcementManagement', new AnnouncementManegementComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-management/announcements-management-module.js